import { useEffect, useRef } from 'react';

/**
 * React 状态钩子，返回先前状态
 * @param state
 * @returns
 */
export default function usePrevious<T>(state: T): T | undefined {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = state;
  });

  return ref.current;
}
